<template>
    <div class="row">
        <div class="col-3">
            <div class="row">
                <div class="col-6">
                    <p class="el-style attribute-name">Minimum interval:</p>
                    <p class="el-style attribute-name">Messages limit:</p>
                </div>
                <div class="col-6">
                    <p>{{ interval }}</p>
                    <p>{{ maxMessages }}</p>
                </div>
            </div>
        </div>
        <div class="col-3">
            <div class="row">
                <div class="col-6">
                    <p class="el-style attribute-name">Created:</p>
                    <p class="el-style attribute-name">Updated:</p>
                </div>
                <div class="col-6">
                    <p>{{ createdAt }}</p>
                    <p>{{ updatedAt }}</p>
                </div>
            </div>
        </div>
        <div class="col-3">
            <div class="row">
                <div class="col-6">
                    <p class="el-style attribute-name">Messages total:</p>
                    <p class="el-style attribute-name">Messages sent:</p>
                </div>
                <div class="col-6">
                    <p>{{ totalMessageCount }}</p>
                    <p>{{ createdMessageCount }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

  export default {
    props: [
      'row'
    ],

    computed: {
      /**
       * @return {string}
       */
      createdAt() {
        return this.formatDate(this.row.model.created_at);
      },

      /**
       * @return {string}
       */
      updatedAt() {
        return this.formatDate(this.row.model.created_at);
      },

      /**
       * @return {string}
       */
      interval() {
        const value = this.row.model.display_min_interval;

        return _.isNull(value) ? '-' : value;
      },

      /**
       * @return {string}
       */
      maxMessages() {
        const value = this.row.model.max_messages;

        return _.isNull(value) ? '-' : value;
      },

      /**
       * @return {number}
       */
      createdMessageCount() {
        return _.get(this.row, 'model.message_count', 0);
      },

      /**
       * @return {number}
       */
      pendingMessageCount() {
        return _.get(this.row, 'model.pending_message_count', 0);
      },

      /**
       * @return {number}
       */
      totalMessageCount() {
        return this.createdMessageCount + this.pendingMessageCount;
      }
    },

    methods: {
      formatDate(value) {
        const datetime = _.get(value, 'datetime', null);

        return _.isNull(datetime)
          ? ''
          : moment(datetime).format(config('format.moment.short.datetime'));
      },
    },
  }
</script>
